<div class="flex h-full w-full justify-center px-4 pt-14">
    <div class="w-full max-w-3xl animate-overlay-appear" (click)="$event.stopPropagation()">
        <div class="relative">
            <iota-icon icon="magnifying-glass" size="1.5" class="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2"></iota-icon>
            <input
                #searchInput
                type="text"
                class="input input-bordered w-full rounded-full pl-14 shadow-2xl"
                [value]="service.query()"
                (input)="onInput($event)"
                (keydown)="onKeydown($event)"
                placeholder="Search employees, customers, products …"
                i18n-placeholder
                data-testid="magicSearchInput"
            />
        </div>

        <div *ngIf="!service.idle()" class="mt-3 overflow-hidden rounded-xl bg-base-100 shadow-2xl" data-testid="magicSearchResults">
            <div class="max-h-[55vh] overflow-y-auto">
                <div *ngIf="service.loading()" class="flex items-center gap-3 px-4 py-6" data-testid="magicSearchLoading">
                    <span i18n>Searching …</span>
                </div>

                <div *ngIf="service.error()" class="px-4 py-6 text-center text-error" data-testid="magicSearchError" i18n>
                    Something went wrong. Please try again.
                </div>

                <div *ngIf="service.empty()" class="px-4 py-6 text-center" data-testid="magicSearchEmpty" i18n>No results found.</div>

                <ng-container *ngIf="service.hasResults()">
                    <div *ngFor="let group of service.indexedGroups()" class="py-2">
                        <p class="px-4 py-1 text-xs font-semibold uppercase tracking-wide" data-testid="magicSearchGroupHeader">
                            {{ group.labelId }}
                        </p>
                        <app-magic-search-result-row
                            *ngFor="let row of group.rows; trackBy: trackByRowKey"
                            [attr.data-row-index]="row.index"
                            [row]="row"
                            [selected]="row.index === service.selectedIndex()"
                            (activate)="service.close()"
                        ></app-magic-search-result-row>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
